// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__N0VPY","modalFooterButton":"ModalNotes_modalFooterButton__1qOXW"};